import { render, staticRenderFns } from "./SiteWorkflowDetails.vue?vue&type=template&id=65960378&scoped=true"
import script from "./SiteWorkflowDetails.vue?vue&type=script&lang=js"
export * from "./SiteWorkflowDetails.vue?vue&type=script&lang=js"
import style0 from "./SiteWorkflowDetails.vue?vue&type=style&index=0&id=65960378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65960378",
  null
  
)

export default component.exports